import { ArrowRight } from "lucide-react";
import Image from "next/image";
import React from "react";

const AiRecommendation = () => {
  return (
    <div className="max-w-[200px] max-h-[150px] bg-white p-3 rounded-[12px] shadow-sm border">
      <Image
        src="/assets/creativeIntelligence/fatigue.svg"
        width={200}
        height={150}
        alt="box"
        className="w-full h-full rounded-[8px] "
      />
      <a
        href=""
        className="flex items-center gap-2 text-[10px] font-semibold mt-2 text-[#6366F1] "
      >
        View Full Plan of Action <ArrowRight size={12} />
      </a>
    </div>
  );
};

export default AiRecommendation;
